import { Modal } from 'components';
import styled from 'styled-components';
import { from } from 'styles/mixins';

export const Container = styled(Modal)`
  & .MuiPaper-root {
    box-sizing: border-box;
    min-height: 100vh;
    padding: 2rem;
    overflow: hidden;

    ${from.mobileXL`
      max-width: 40rem;
      min-height: unset;
      width: 90vw;
    `};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Paragraph = styled.p`
  width: 100%;

  :first-of-type {
    margin: 0;
  }

  strong {
    font-weight: ${({ theme }) => theme.weights.semiBold};
  }
`;

export const Plans = styled.div`
  display: flex;

  > *:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacing.md};
  }
`;
